import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.HospitalityEnquiryForm = class HospitalityEnquiryForm extends Snappy.BaseComponent {
    static get tagName(){
        return 'fa-hospitality-enquiry-form';
    }

    constructor(element) {
        super(element);

        $(".scrollTo").on('click',
            function (e) {
                e.preventDefault();
                var target = $(this).attr('href');
                $('html, body').animate({
                        scrollTop : ($(target).offset().top - 150)
                    },
                    800);

                var packageId = $(this).attr('name');
                $(".packageCheckbox").each(function(i, val) {
                    $(this).prop('checked', val.name.toLowerCase() == "package_{" + packageId + "}");
                });
            });
    }

    render() {
        this.setVars();
        this.addEventListeners();
    }

    setVars() {
        this.$form = this.$element.find('.fa-hospitality-enquiry-form__form');
        this.$messageContainer = this.$element.find('.message-container');
        this.errorClass = 'fa-input-field--error';
        this.messageClass = 'fa-input-field__error-message';
    }

    addEventListeners() {
        this.$form.on('submit', this.onFormSubmission.bind(this));
    }

    onFormSubmission(event) {
        event.preventDefault();

        var offersUpdatesFieldVal = false;
        if ($('#offersUpdatesField') && $('#offersUpdatesField:checked').length !== 0) {
            offersUpdatesFieldVal = true;
        }

        var nflFieldVal = false;
        if ($('#nflField') && $('#nflField:checked').length !== 0) {
            nflFieldVal = true;
        }

        var formData = {
            Title: { FieldName: "titleField", FieldValue: $("#title-field :selected").val() },
            FirstName: { FieldName: "firstNameField", FieldValue: $("#firstName-field").val() },
            LastName: { FieldName: "lastNameField", FieldValue: $("#lastName-field").val() },
            EmailAddress: { FieldName: "emailField", FieldValue: $("#email-field-main").val() },
            PhoneNumber: { FieldName: "telephoneField", FieldValue: $("#telephone-field").val() },
            Enquiry: { FieldName: "enquiryField", FieldValue: $("#enquiry-field").val() },
            AgeRange: { FieldName: "ageField", FieldValue: $("#age-field :selected").val() },
            Postcode: { FieldName: "postcodeField", FieldValue: $("#postcode-field").val() },
            EventsInterest: { FieldName: "eventsInterest", FieldValue: $("input.packageCheckbox:checked").val() },
            ReceiveOffers: offersUpdatesFieldVal,
            NFLConsent: nflFieldVal
        };

        $.ajax({
                beforeSend: function() {
                    $('.loading-message-wrapper').removeClass('hide').addClass('show');
                },
                url: this.formAction = this.$form.attr('action'),
                method: this.formMethod = this.$form.attr('method'),
                data: this.formData = formData
            })
            .always(this.handleValidationResponse.bind(this));
    }

    handleValidationResponse(response) {
        this.hideAllValidationErrors();
        if (!response.success) {
            $('html, body').animate({
                    scrollTop : ($('.form-title').offset().top)
                },
                800);

            $.each(response.fields,
                (i, field) =>{
                    this.showValidationError(field);
                    const activeClass = 'active';

                    //this.resetForm();
                    this.$messageContainer.removeClass(activeClass);
                    $(".loading-message-wrapper").delay(500).queue(function (next) {
                        $(this).removeClass('show').addClass('hide');
                        next();
                    });
                });
        }
        else {
            this.handleSuccess(response);
        }
    }

    hideAllValidationErrors() {
        $(".fa-input-field--error").each(function () {
            $(this).removeClass("fa-input-field--error");
        });
    }

    showValidationError(field) {
        const $element = this.$form.find(`[name=${field.FieldName}]`);

        $element
            .addClass(this.errorClass)
            .parent()
            .addClass(this.errorClass)
            .find(`.${this.messageClass}`).text(field.Reason);
    }

    removeValidationError(field) {
        const $element = this.$form.find(`[name=${field.element}]`);

        $element
            .removeClass(this.errorClass)
            .parent()
            .removeClass(this.errorClass)
            .find(`.${this.messageClass}`).text('');
    }

    handleSuccess(response) {

        dataLayer.push({ 'crmUserId' : response.CrmUserId });
        dataLayer.push({ 'thankYouURL' : window.location.href + '/thankyou' });

        window.location.replace("/hospitalityconfirmation");
    }

    resetForm() {
        this.$form.find('input, select, textarea').each((i, element) =>{
            element.value = '';
        });
    }
}

$(function() {
    new Snappy.Component.HospitalityEnquiryForm();

    $('.packageCheckbox').change(function() {
        $('.packageCheckbox').not(this).prop('checked', false);
    });

    //Event Dropdown
    var defaultDescription = $('ul.fa-dropdown-content li.description-default');
    var eventDescription = $('ul.fa-dropdown-content li.description');

    $(eventDescription).hide();
    $(defaultDescription).show();

    $('.fa-dropdown select#event-title').change(function() {
        $(defaultDescription).hide();
        $(eventDescription).hide();
        $('#' + this.value).show();

        if ($(this).val() == '0') {
            $(defaultDescription).show();
        }
    });
});



// WEBPACK FOOTER //
// ./components/cw-enquiryForm/scripts/hospitalityEnquiryForm.js